import { MDBIcon, MDBInput, MDBTable, MDBDataTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import React, { Component } from 'react';
import { GrDetalleSeguros_, DetalleSeguros_, GrSegurosConfiguracion_, SegurosConfiguracion_, CargueImagenes, CargueDocumentos } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';
import { URLImgFront } from '../../../config/URLDB';
import { MDBModal, MDBModalHeader, MDBModalBody } from 'mdbreact';
import FileUploaderUpdate from "./ImagenTexto/FileUploaderUpdate";

const ValidarFormulario = (campos) => {
    let errors = {};
    const mensajeerror = 'Campo obligatorio';
    const { idtipopers, idtiposeguro, nombre, descripcion, rutaimg, titulo, idtipoenlace, rutaconfig, nombrepdf, rutaicono } = campos;
    if (idtiposeguro !== undefined && idtiposeguro === 'DEFAULT') {
        errors.idtiposeguro = mensajeerror;
    }
    if (idtipopers !== undefined && idtipopers === 'DEFAULT') {
        errors.idtipopers = mensajeerror;
    }
    if (nombre !== undefined && nombre.trim() === '') {
        errors.nombre = mensajeerror;
    }
    if (descripcion !== undefined && descripcion.trim() === '') {
        errors.descripcion = mensajeerror;
    }
    if (rutaimg !== undefined && rutaimg === '') {
        errors.rutaimg = 'Imagen obligatoria';
    }
    if (titulo !== undefined && titulo.trim() === '') {
        errors.titulo = mensajeerror;
    }
    if (idtipoenlace !== undefined) {
        if (idtipoenlace === 'DEFAULT') {
            errors.idtipoenlace = mensajeerror;
        }
        else if (idtipoenlace === '1' && rutaconfig.trim() === '') {
            errors.rutaconfig = mensajeerror;
        }
        else if (idtipoenlace === '2' && nombrepdf === '') {
            errors.rutaconfig = mensajeerror;
        }
    }
    else if (rutaconfig !== undefined && rutaconfig.trim() === '') {
        errors.rutaconfig = mensajeerror;
    }
    if (rutaicono !== undefined && rutaicono === '') {
        errors.rutaicono = 'Imagen obligatoria';
    }

    return errors;
};

class Seguro extends Component {
    uploader = React.createRef();
    rutacarpetaimg = '/Seguros/Cards/';
    idusuario = parseInt(sessionStorage.getItem('idusuario'));
    estadosregistros = {
        0: { nuevoestado: 1, mensaje: 'activo' },
        1: { nuevoestado: 0, mensaje: 'inactivo' }
    }
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            nuevoseguro: false,
            nuevoitemconfig: false,
            editarseguro: false,
            editaritemconfig: false,
            infoseguros: [],
            infoitems: [],
            tipositemssegu: [],
            registrositems: [],
            idtipoitemseleccionado: 0,
            idseguroseleccionado: 0,
            titulomodal: '',
            cambiarimg: true,
            seguro: {
                idseguro: 0,
                idtipopers: 'DEFAULT',
                idtiposeguro: 'DEFAULT',
                rutaimg: '',
                nombre: '',
                descripcion: ''
            },
            itemconfig: {
                idconfitem: 0,
                idseguitem: 0,
                titulo: '',
                descripcion: '',
                rutaicono: '',
                idtipoenlace: 'DEFAULT',
                rutaconfig: '',
                archivopdf: null
            }
        };
    }

    async componentDidMount() {
        await this.CargarSeguros();
    }

    ObtenerRegistro = (tran, idseguro = 0, idconfigseguitem = 0, estado = 0) => {
        let idtiposeguro = 0;
        let idseguitem = 0;
        let idtipopers = 0;
        let nombre = 'NA';
        let titulo = 'NA';
        let descripcion = 'NA';
        let rutaimg = 'NA';
        let rutaicono = 'NA';
        let idtipoenlace = 0;
        let rutaconfig = 'NA';
        let orden = 0;
        let idusucrea = 0;
        if (tran === 1) { // GUARDAR O ACTUALIZAR.
            const { nuevoseguro, editarseguro, seguro } = this.state;
            if (nuevoseguro || editarseguro) {
                ({ nombre, idtipopers, nombre, descripcion, idtiposeguro, descripcion, rutaimg } = seguro);
                estado = idseguro === 0 ? 1 : seguro.estado;
            }
            else {
                const { itemconfig, idseguroseleccionado, idtipoitemseleccionado } = this.state;
                ({ idseguitem, titulo, descripcion, rutaicono, rutaconfig, idtipoenlace } = itemconfig);
                estado = idconfigseguitem === 0 ? 1 : itemconfig.estado;
                idseguro = idseguro || idseguroseleccionado;
                idseguitem = idseguitem || idtipoitemseleccionado;
                idtipoenlace = parseInt(idtipoenlace) || 3;
                if (idtipoenlace === 2) { // 2 - DOCUMENTO.
                    rutaconfig = itemconfig.nombrepdf;
                }
                else if (idtipoenlace === 3) { // 3 - NINGUNO.
                    rutaconfig = 'NA';
                }
            }
            idusucrea = this.idusuario;
        }
        else if (tran === 6 || tran === 7) { // ACTUALIZAR ESTADO.
            idusucrea = this.idusuario;
        }
        const datos = { tran, idconfigseguitem, idseguro, idtiposeguro, idseguitem, idtipopers, nombre, titulo, descripcion, rutaicono, rutaimg, idtipoenlace, rutaconfig, orden, estado, idusucrea };
        return datos;
    }

    MostrarModal = (mensaje, idicono = 0) => {
        let iconos = ['error', 'success'];
        Swal.fire({
            icon: iconos[idicono],
            title: mensaje
        });
    }

    CargarSeguros = async () => {
        this.setState({
            errors: {}
        });
        const datos = this.ObtenerRegistro(7);
        try {
            const registros = await DetalleSeguros_(datos);
            const cantregistros = registros?.length ?? 0;
            const sinresultados = registros[0]?.message === '004404';
            if (cantregistros > 0 && !sinresultados) {
                this.setState({
                    infoseguros: registros
                });
            }
            else {
                this.setState({
                    nuevoseguro: true
                });
            }
        }
        catch {
            this.MostrarModal('Ocurrio un error!');
            this.setState({
                nuevoseguro: true
            });
        }
    }

    CargarItems = async () => {
        this.setState({
            errors: {}
        });
        const datos = this.ObtenerRegistro(8, this.state.idseguroseleccionado);

        try {
            const registros = await SegurosConfiguracion_(datos);
            const cantregistros = registros?.length ?? 0;
            const sinresultados = registros[0]?.message === '004404';
            if (cantregistros > 0 && !sinresultados) {
                const items = [];
                for (const item of registros) {
                    const { idseguitem, nombitem } = item;
                    if (!items.some(item => item.idseguitem === idseguitem)) {
                        items.push({ idseguitem, nombitem });
                    }
                }
                this.setState({
                    infoitems: registros,
                    tipositemssegu: items
                }, () => {
                    const itemseleccionado = items[0].idseguitem;
                    this.ConfigurarItems(itemseleccionado);
                });
            }
        }
        catch {
            this.HandleNewModulo();
            this.MostrarModal('Ocurrio un error!');
        }
    }

    ConfigurarItems = (idseguitem) => {
        let registrositems = [];
        const infoitems = this.state.infoitems;
        for (const item of infoitems) {
            if (item.idseguitem === idseguitem) {
                registrositems.push(item);
            }
        }
        this.setState({
            registrositems,
            idtipoitemseleccionado: idseguitem,
            nuevoitemconfig: false,
            editaritemconfig: false
        });
    }

    ActualizarEstadoSeguro = async (idseg, estado) => {
        estado = this.estadosregistros[estado];
        const datos = this.ObtenerRegistro(6, idseg, 0, estado.nuevoestado);
        try {
            const registros = await GrDetalleSeguros_(datos);
            if (registros) {
                this.MostrarModal(`Se ${estado.mensaje} satisfactoriamente`, 1);
                await this.CargarSeguros();
            }
            else {
                this.MostrarModal('Error al actualizar estado.');
            }
        }
        catch {
            this.MostrarModal('Ocurrio un error!');
        }
    }

    ActualizarEstadoItemConfig = async (iditemconfig, estado) => {
        estado = this.estadosregistros[estado];
        const datos = this.ObtenerRegistro(7, 0, iditemconfig, estado.nuevoestado);
        try {
            const registros = await GrSegurosConfiguracion_(datos);
            if (registros) {
                this.MostrarModal(`Se ${estado.mensaje} satisfactoriamente`, 1);
                await this.CargarItems();
            }
            else {
                this.MostrarModal('Error al actualizar estado.');
            }
        }
        catch {
            this.MostrarModal('Ocurrio un error!');
        }
    }

    InsertarSeguro = async () => {
        const seguro = this.state.seguro;
        const camposincompletos = ValidarFormulario(seguro);
        this.setState({
            errors: camposincompletos
        });
        const id = seguro.idseguro;
        if (Object.keys(camposincompletos).length === 0) {
            const datos = this.ObtenerRegistro(1, id);
            const guardarregistro = id > 0 ? this.ValidarCambios(id) : true;
            if (guardarregistro) {
                try {
                    const registros = await GrDetalleSeguros_(datos);
                    if (registros.length > 0) {
                        if (registros[0].message === '000000') {
                            const datoscargados = await this.CargarImagen();
                            if (!datoscargados) {
                                await this.CargarSeguros();
                            }
                            this.MostrarModal('Se inserto correctamente.', 1);
                            this.setState({
                                nuevoseguro: false,
                                editarseguro: false
                            });
                        }
                        else {
                            this.MostrarModal('Error al insertar.');
                        }
                    }
                    else {
                        this.MostrarModal('Ocurrio un error!');
                    }
                }
                catch {
                    this.MostrarModal('Ocurrio un error!');
                }
            }
            else {
                this.MostrarModal('Se inserto correctamente.', 1);
            }
        }
    }

    InsertarItemConfig = async () => {
        const itemconfig = this.state.itemconfig;
        const resultado = ValidarFormulario(itemconfig);
        this.setState({
            errors: resultado
        });
        const { idseguro, idconfitem } = itemconfig;
        if (Object.keys(resultado).length === 0) {
            const datos = this.ObtenerRegistro(1, idseguro, idconfitem);
            const guardarregistro = idconfitem > 0 ? this.ValidarCambios(idconfitem) : true;
            if (guardarregistro) {
                try {
                    const registros = await GrSegurosConfiguracion_(datos);
                    if (registros.length > 0) {
                        if (registros[0].message === '000000') {
                            let datoscargados = await this.CargarArchivo();
                            datoscargados = await this.CargarImagen();
                            if (!datoscargados) {
                                await this.CargarItems()
                            }
                            this.MostrarModal('Se inserto correctamente.', 1);
                            this.setState({
                                nuevoitemconfig: false,
                                editaritemconfig: false
                            });
                        }
                        else {
                            this.MostrarModal('Error al insertar.');
                        }
                    }
                    else {
                        this.MostrarModal('Ocurrio un error!');
                    }
                }
                catch {
                    this.MostrarModal('Ocurrio un error!');
                }
            }
            else {
                this.MostrarModal('Se inserto correctamente.', 1);
            }
        }
    }

    ValidarCambios = (id) => {
        const { nuevoseguro, editarseguro, infoseguros, seguro, registrositems, itemconfig } = this.state;
        let cambios = false;
        let datosoriginales = {};
        let datosnuevos = {};
        if (nuevoseguro || editarseguro) {
            datosoriginales = Object.values(infoseguros).find(registro => registro.idseguro === id);
            let { idtipopers, idtiposeguro } = seguro;
            idtipopers = parseInt(idtipopers);
            idtiposeguro = parseInt(idtiposeguro);
            datosnuevos = { ...seguro, idtipopers, idtiposeguro };
            cambios = Object.keys(datosnuevos).some(campo => datosoriginales[campo] !== datosnuevos[campo]);
        }
        else {
            datosoriginales = Object.values(registrositems).find(registro => registro.idconfitem === id);
            const idtipoenlace = parseInt(itemconfig.idtipoenlace);
            const rutaconfig = idtipoenlace === 2 ? itemconfig.nombrepdf : itemconfig.rutaconfig;
            datosnuevos = { ...itemconfig, idtipoenlace, rutaconfig };
            cambios = Object.keys(datosoriginales).some(campo => datosoriginales[campo] !== datosnuevos[campo]);
        }
        return cambios;
    }

    CargarImagen = async () => {
        let imgcargada = false;
        const archivoimg = this.uploader?.current ?? null;
        const imagen = archivoimg !== null ? archivoimg.getFileObject() : null;
        if (archivoimg && imagen) {
            const formulario = new FormData();
            const rutaimagen = `${this.rutacarpetaimg}${archivoimg.getFileName()}`;
            formulario.append('file', imagen);
            formulario.append('rutaImagen', rutaimagen);
            try {
                const peticion = await CargueImagenes(formulario);
                if (peticion) {
                    imgcargada = true;
                    if (this.state.nuevoseguro || this.state.editarseguro) {
                        await this.CargarSeguros()
                    }
                    else {
                        await this.CargarItems()
                    }
                }
            }
            catch {
                this.MostrarModal('Error al cargar la imagen!');
            }
        }
        return imgcargada;
    }

    CargarArchivo = async () => {
        let pdfcargado = false;
        const { archivopdf, nombrepdf } = this.state.itemconfig;
        if (archivopdf !== null) {
            const formulario = new FormData();
            const rutaarchivo = `/Archivos/${nombrepdf}`;
            formulario.append('file', archivopdf, nombrepdf);
            formulario.append('rutaImagen', rutaarchivo);
            try {
                const peticion = await CargueDocumentos(formulario);
                if (peticion) {
                    pdfcargado = true;
                    await this.CargarItems();
                }
            }
            catch {
                this.MostrarModal('Error al cargar el archivo PDF!');
            }
        }
        return pdfcargado;
    }

    TextInput = (registro, evento, tiporegistro = 0) => {
        const nombregistro = tiporegistro === 0 ? 'seguro' : 'itemconfig';
        const campo = evento.target.name;
        const valor = evento.target.value
        this.setState({
            [nombregistro]: {
                ...registro,
                [campo]: valor
            }
        });
    }

    OnFileChange = (evento) => {
        const archivo = evento?.target?.files[0] ?? null;
        this.setState({
            itemconfig: {
                ...this.state.itemconfig,
                archivopdf: archivo,
                nombrepdf: archivo?.name ?? ''
            }
        });
    };

    CambioImagen = (nombreimg) => {
        const { nuevoseguro, editarseguro, seguro, itemconfig } = this.state;
        const registro = nuevoseguro || editarseguro ? seguro : itemconfig;
        const nombregistro = nuevoseguro || editarseguro ? 'seguro' : 'itemconfig';
        const campoimg = nuevoseguro || editarseguro ? 'rutaimg' : 'rutaicono';
        this.setState({
            cambiarimg: true,
            [nombregistro]: {
                ...registro,
                [campoimg]: `${this.rutacarpetaimg}${nombreimg.toLowerCase()}`
            }
        });
    }

    LimpiarRegistro = () => {
        this.setState({
            cambiarimg: true,
            errors: {},
            seguro: {
                idseguro: 0,
                idtipopers: 'DEFAULT',
                idtiposeguro: 'DEFAULT',
                rutaimg: '',
                nombre: '',
                descripcion: ''
            },
            itemconfig: {
                idconfitem: 0,
                idseguitem: 0,
                titulo: '',
                descripcion: '',
                rutaicono: '',
                idtipoenlace: 'DEFAULT',
                rutaconfig: '',
                archivopdf: null,
                nombrepdf: ''
            }
        });
    }

    HandleNewModulo = (registro = null) => {
        this.setState({
            editarseguro: false,
            nuevoseguro: !this.state.nuevoseguro
        });
        if (registro !== null) {
            this.setState({
                nuevoseguro: true,
                editarseguro: true,
                cambiarimg: false,
                seguro: registro
            });
        }
        else {
            this.LimpiarRegistro();
        }
    }

    HandleNewModal = (item = null) => {
        this.setState({
            editaritemconfig: false,
            nuevoitemconfig: !this.state.nuevoitemconfig
        });
        if (item !== null) {
            this.setState({
                nuevoitemconfig: true,
                editaritemconfig: true,
                cambiarimg: false,
                itemconfig: {
                    ...item,
                    archivopdf: null,
                    rutaconfig: item.idtipoenlace === 1 ? item.rutaconfig : '',
                    nombrepdf: item.idtipoenlace === 2 ? item.rutaconfig : ''
                }
            });
        }
        else {
            this.LimpiarRegistro();
        }
    };

    AbrirModalConfiguracion = (datos) => {
        let { idseguro, nombre } = datos;
        this.setState({
            abrirmodal: true,
            titulomodal: nombre,
            idtipoitemseleccionado: 0,
            idseguroseleccionado: idseguro
        }, () => {
            this.CargarItems()
        });
        this.LimpiarRegistro();
    }

    CerrarModalConfiguracion = () => {
        this.setState({
            abrirmodal: false,
            nuevoitemconfig: false,
            editaritemconfig: false,
            idseguroseleccionado: 0
        });
        this.LimpiarRegistro();
    };

    MensajeError = (error, posicion = '', altura = 0) => {
        const mensaje = error && <strong className="text-danger" style={{ fontSize: '13px', position: `${posicion}`, top: `${altura}px` }}>{error}</strong>;
        return mensaje;
    }

    render() {
        const { errors, nuevoseguro, nuevoitemconfig, editarseguro, editaritemconfig, cambiarimg, infoseguros, tipositemssegu, registrositems, idtipoitemseleccionado, titulomodal, seguro, itemconfig } = this.state;

        const sindatos = (columnas) => <>
            <tr className="alert alert-info text-center w-100">
                <td colSpan={columnas}>Sin resultados</td>
            </tr>
        </>;
        const botonheader = editarseguro || nuevoseguro ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Crear Seguro &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>

        const tiposseguros = [
            { idtiposeguro: 1, descripcion: 'PREVISIÓN EXEQUIAL' },
            { idtiposeguro: 2, descripcion: 'PROTECCIÓN' }
        ];
        const tipospersonas = [
            { idtipopers: 0, desctipopers: 'JURIDICA' },
            { idtipopers: 1, desctipopers: 'NATURAL' }
        ];

        const tipoguardado = editarseguro || editaritemconfig ? 'Editar' : 'Crear';
        const nombimagensegu = seguro.rutaimg.split('/').pop();
        const formulario = <>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 my-3 text-center">
                        {this.MensajeError(errors.rutaimg)}
                        <FileUploaderUpdate ref={this.uploader} ruta={seguro.rutaimg} estadoImg={cambiarimg} nombreImg={nombimagensegu} FCambiar={this.CambioImagen} />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <MDBInput label="Nombre Seguro" name="nombre" type="text" value={seguro.nombre} onChange={evento => this.TextInput(seguro, evento)} />
                        {this.MensajeError(errors.nombre, 'absolute', 50)}
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-2">
                        <label>Tipo de Seguro</label>
                        <select name="idtiposeguro" className="form-control" value={seguro.idtiposeguro} onChange={evento => this.TextInput(seguro, evento)}>
                            <option value="DEFAULT" disabled>Seleccione...</option>
                            {tiposseguros.map(tiposeg => <option key={tiposeg.idtiposeguro} value={tiposeg.idtiposeguro}> {tiposeg.descripcion}</option>)}
                        </select>
                        {this.MensajeError(errors.idtiposeguro)}
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-2">
                        <label>Tipo de Persona</label>
                        <select name="idtipopers" className="form-control" value={seguro.idtipopers} onChange={evento => this.TextInput(seguro, evento)}>
                            <option value="DEFAULT" disabled>Seleccione...</option>
                            {tipospersonas.map(tipopers => <option key={tipopers.idtipopers} value={tipopers.idtipopers}> {tipopers.desctipopers}</option>)}
                        </select>
                        {this.MensajeError(errors.idtipopers)}
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <label className="my-0" htmlFor="descripcion">Descripción</label>
                        <textarea placeholder="Puedes ingresar código <HTML />" className="form-control textarea-editor" type="textarea" rows="5" name="descripcion" value={seguro.descripcion} onChange={evento => this.TextInput(seguro, evento)} />
                        {this.MensajeError(errors.descripcion)}
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end pt-2 mt-5 w-100 modal-footer">
                <button type="button" className="btn btn-primary px-5" onClick={async () => await this.InsertarSeguro()}>{tipoguardado} Seguro &nbsp; <MDBIcon icon="save" /></button>
            </div>
        </>;

        let contenidomodulo = formulario;
        if (!nuevoseguro && !editarseguro) {
            contenidomodulo = <div className="container-fluid">
                <div className="table-responsive text-center w-100">
                    <MDBTable>
                        <MDBTableHead>
                            <tr className="font-weight-bold elemento-centrado">
                                <td>Tipo de seguro</td>
                                <td>Tipo de Persona</td>
                                <td>Nombre</td>
                                <td>Descripción</td>
                                <td>Imagen</td>
                                <td>Editar</td>
                                <td>Inactivar</td>
                                <td>Configuración</td>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {sindatos(8)}
                        </MDBTableBody>
                    </MDBTable>
                </div>
            </div>;
            if (infoseguros.length > 0) {
                contenidomodulo = <div className="container-fluid">
                                      <div className="table-responsive text-center w-100">
                                          <MDBDataTable
                                              className="elemento-centrado"
                                              noRecordsFoundLabel="No hay registros para mostrar"
                                              data={{
                                                  columns: [
                                                      { label: 'Tipo de seguro', field: 'tiposeguro' },
                                                      { label: 'Tipo de Persona', field: 'tipopers' },
                                                      { label: 'Nombre', field: 'nombre' },
                                                      { label: 'Descripción', field: 'descripcion' },
                                                      { label: 'Imagen', field: 'imagen' },
                                                      { label: 'Editar', field: 'editar' },
                                                      { label: 'Inactivar', field: 'inactivar' },
                                                      { label: 'Configuración', field: 'itemsconfig' }
                                                  ],
                                                  rows: infoseguros.map(seguro => {
                                                      const { idseguro, nombre, descripcion, tiposeguro, tipopers, rutaimg, estado } = seguro;
                                                      const iconoItem = estado === 1 ? 'eye' : 'eye-slash';
                                                      const fila = {
                                                          tiposeguro,
                                                          nombre,
                                                          descripcion,
                                                          tipopers,
                                                          imagen: <img width="150" src={`${URLImgFront}/assets/${rutaimg}`} alt={rutaimg} />,
                                                          editar: <MDBIcon icon="edit" size="2x" style={{ color: 'green', cursor: 'pointer' }} onClick={() => this.HandleNewModulo(seguro)} />,
                                                          inactivar: <MDBIcon icon={iconoItem} size="2x" style={{ cursor: 'pointer' }} onClick={async () => await this.ActualizarEstadoSeguro(idseguro, estado)} />,
                                                          itemsconfig: <MDBIcon onClick={() => { this.AbrirModalConfiguracion(seguro) }} className="text-center" icon="bars" size="2x" style={{ color: 'orange', cursor: 'pointer' }} />
                                                      }
                                                      return fila;
                                                  })
                                              }}
                                              infoLabel={['Mostrando', 'a', 'de', 'registros']}
                                              entriesLabel="Registros por página"
                                              searchLabel="Buscar"
                                              paginationLabel={['Anterior', 'Siguiente']}
                                          />
                                      </div>
                                  </div>;
            }
        }

        // GENERACIÓN DE LA MODAL DE LOS ITEMS
        const tiposenlaces = [
            { indice: 1, descripcion: 'URL redireccionar' },
            { indice: 2, descripcion: 'Documento' },
            { indice: 3, descripcion: 'Ninguno' }
        ];
        let opcionesbanner = <></>;
        let btnmodalheader = <></>;
        if (tipositemssegu.length > 0) {
            btnmodalheader = editaritemconfig || nuevoitemconfig ? <p>Cancelar &nbsp; <MDBIcon icon="times" size="lg" /></p> : <p>Crear registro &nbsp; <MDBIcon icon="plus-circle" size="lg" /></p>;
            opcionesbanner = tipositemssegu.map((item) => {
                const itemactivo = idtipoitemseleccionado === item.idseguitem ? 'item-activo' : '';
                const opcion = <li key={item.idseguitem} onClick={() => this.ConfigurarItems(item.idseguitem)} className={itemactivo} style={{ position: 'relative', cursor: 'pointer' }}>
                    {item.nombitem}
                </li>;
                return opcion;
            });
        }
        let campoenlace = <></>;
        if (itemconfig.idtipoenlace.toString() === '1') { // 1 - URL REDIRECCIONAR
            campoenlace = <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pt-3">
                <MDBInput label="Url redireccionar" name="rutaconfig" type="text" value={itemconfig.rutaconfig} onChange={evento => this.TextInput(itemconfig, evento, 1)} />
                {this.MensajeError(errors.rutaconfig, 'absolute', 65)}
            </div>;
        }
        else if (itemconfig.idtipoenlace.toString() === '2') { // 2 - DOCUMENTO PDF
            const archivopdf = itemconfig.nombrepdf || "No se ha seleccionado ningún archivo PDF...";
            campoenlace = <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 py-3">
                <div className="form-group">
                    <div className="custom-file">
                        <input type="file" className="custom-file-input" id="archivopdf" name="archivopdf" title={archivopdf} onChange={this.OnFileChange} />
                        <label className="custom-file-label text-truncate mt-1" htmlFor="archivopdf">
                            {archivopdf}
                        </label>
                        {this.MensajeError(errors.rutaconfig)}
                    </div>
                </div>
            </div>;
        }
        const nombimagenitem = itemconfig.rutaicono !== 'NA' && itemconfig.rutaicono !== undefined ? itemconfig.rutaicono.split('/').pop() : '';
        const rutaimagenitem = itemconfig.rutaicono !== 'NA' && itemconfig.rutaicono !== undefined ? itemconfig.rutaicono : '';
        const lngcampotitulo = itemconfig.idtipoenlace === 'DEFAULT' || itemconfig.idtipoenlace.toString() === '3' ? 'col-xl-6 col-lg-6 col-md-6' : 'col-xl-12 col-lg-12 col-md-12';
        const formularioconfig = <>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 my-3 text-center">
                        {this.MensajeError(errors.rutaicono)}
                        <FileUploaderUpdate ref={this.uploader} ruta={rutaimagenitem} estadoImg={cambiarimg} nombreImg={nombimagenitem} FCambiar={this.CambioImagen} />
                    </div>
                    <div className={`${lngcampotitulo} col-sm-12 col-12`}>
                        <MDBInput label="Nombre" name="titulo" type="text" value={itemconfig.titulo} onChange={evento => this.TextInput(itemconfig, evento, 1)} />
                        {this.MensajeError(errors.titulo, 'absolute', 50)}
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pb-4">
                        <label className="my-0" htmlFor="idtipoenlace">Tipo de Enlace</label>
                        <select id="idtipoenlace" name="idtipoenlace" className="form-control" value={itemconfig.idtipoenlace} onChange={evento => this.TextInput(itemconfig, evento, 1)}>
                            <option value="DEFAULT" disabled>Seleccione...</option>
                            {tiposenlaces.map(tipoenlace => <option key={tipoenlace.indice} value={tipoenlace.indice}> {tipoenlace.descripcion}</option>)}
                        </select>
                        {this.MensajeError(errors.idtipoenlace)}
                    </div>
                    {campoenlace}
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <label className="my-0" htmlFor="descripcion">Descripción</label>
                        <textarea placeholder="Puedes ingresar código <HTML />" className="form-control textarea-editor" type="textarea" rows="5" name="descripcion" value={itemconfig.descripcion} onChange={evento => this.TextInput(itemconfig, evento, 1)} />
                        {this.MensajeError(errors.descripcion)}
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end pt-2 mt-5 w-100">
                <button type="button" className="btn btn-primary px-5" onClick={async () => await this.InsertarItemConfig()}>{tipoguardado} Registro &nbsp; <MDBIcon icon="save" /></button>
            </div>
        </>;

        let contenidomodal = formularioconfig;
        if (!nuevoitemconfig && !editaritemconfig) {
            let filasitems = sindatos(6);
            if (registrositems.length > 0) {
                filasitems = registrositems.map(item => {
                    const { idconfitem, titulo, descripcion, rutaicono, rutaconfig, estado } = item;
                    const campoimg = rutaicono !== 'NA' ? <img width="150" src={`${URLImgFront}/assets/${rutaicono}`} alt={rutaicono} /> : <text>{rutaicono}</text>
                    const iconoItem = estado === 1 ? 'eye' : 'eye-slash';
                    const fila = <React.Fragment key={idconfitem}>
                        <tr className="elemento-centrado">
                            <td>{titulo}</td>
                            <td>{descripcion}</td>
                            <td>{campoimg}</td>
                            <td>{rutaconfig}</td>
                            <td className="text-center">
                                <MDBIcon icon="edit" size="2x" style={{ color: 'green', cursor: 'pointer' }} onClick={() => this.HandleNewModal(item)} />
                            </td>
                            <td className="text-center">
                                <MDBIcon icon={iconoItem} size="2x" style={{ cursor: 'pointer' }} onClick={async () => await this.ActualizarEstadoItemConfig(idconfitem, estado)} />
                            </td>
                        </tr>
                    </React.Fragment>;
                    return fila;
                });
            }
            contenidomodal = <div className="container-fluid elemento-centrado">
                <div className="table-responsive text-center w-100">
                    <MDBTable>
                        <MDBTableHead>
                            <tr className="font-weight-bold">
                                <td>Nombre del Plan</td>
                                <td>Descripción</td>
                                <td>Imagen</td>
                                <td>Url del enlace</td>
                                <td>Editar</td>
                                <td>Inactivar</td>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {filasitems}
                        </MDBTableBody>
                    </MDBTable>
                </div>
            </div>;
        }
        const modalconfig = <MDBModal isOpen={this.state.abrirmodal} toggle={this.CerrarModalConfiguracion} className="bg-white modal-items">
            <MDBModalHeader toggle={this.CerrarModalConfiguracion}>
                CONFIGURACIÓN SEGURO {titulomodal.toUpperCase()}
            </MDBModalHeader>
            <MDBModalBody>
                <div className="row g-3">
                    <div className="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-12">
                        <div className="listado_banner" style={{ position: 'static' }}>
                            <ul>
                                {opcionesbanner}
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-10 col-lg-9 col-md-12 col-sm-12 col-12">
                        <div className="plus_add_agencia align-items-center d-flex" onClick={() => this.HandleNewModal()}>
                            {btnmodalheader}
                        </div>
                        <br />
                        <div className="mt-2 pl-4 w-100">
                            {contenidomodal}
                        </div>
                    </div>
                </div>
            </MDBModalBody>
        </MDBModal>;

        const jsx = <>
            <p className="font-weight-bold">Seguros EMCOOFUN y EQUIDAD</p>
            <hr />
            <div className="plus_add_agencia align-items-center d-flex" onClick={() => this.HandleNewModulo()}>
                {botonheader}
            </div>
            {contenidomodulo}
            {modalconfig}
        </>;

        return jsx;
    }
}

export default Seguro;